var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.item.config && !!_vm.item.config.frontend)?_c('InfoBranch',{style:({
    marginTop: '2px',
  }),attrs:{"content":_vm.conditionText}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }